/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.WorldImageryApi = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * WorldImagery service.
   * @module api/WorldImageryApi
   * @version 1.0.0
   */

  /**
   * Constructs a new WorldImageryApi. 
   * @alias module:api/WorldImageryApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the getTileByXyzV1 operation.
     * @callback module:api/WorldImageryApi~getTileByXyzV1Callback
     * @param {String} error Error message, if any.
     * @param {'Blob'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a World Imagery tile by XYZ.
     * @param {Number} srid The SRID in which to generate the tile. Currently only \&quot;3857\&quot; is supported.
     * @param {Number} tileZ The Z value (zoom level) of the tile to get.
     * @param {Number} tileX The X value (matrix column) of the tile to get.
     * @param {Number} tileY The Y value (matrix row) of the tile to get.
     * @param {String} fileExtension The image format of the tile to get. Currently only \&quot;jpeg\&quot; and \&quot;jpg\&quot; are supported.
     * @param {module:api/WorldImageryApi~getTileByXyzV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Blob'}
     */
    this.getTileByXyzV1 = function(srid, tileZ, tileX, tileY, fileExtension, callback) {
      var postBody = null;

      // verify the required parameter 'srid' is set
      if (srid === undefined || srid === null) {
        throw new Error("Missing the required parameter 'srid' when calling getTileByXyzV1");
      }

      // verify the required parameter 'tileZ' is set
      if (tileZ === undefined || tileZ === null) {
        throw new Error("Missing the required parameter 'tileZ' when calling getTileByXyzV1");
      }

      // verify the required parameter 'tileX' is set
      if (tileX === undefined || tileX === null) {
        throw new Error("Missing the required parameter 'tileX' when calling getTileByXyzV1");
      }

      // verify the required parameter 'tileY' is set
      if (tileY === undefined || tileY === null) {
        throw new Error("Missing the required parameter 'tileY' when calling getTileByXyzV1");
      }

      // verify the required parameter 'fileExtension' is set
      if (fileExtension === undefined || fileExtension === null) {
        throw new Error("Missing the required parameter 'fileExtension' when calling getTileByXyzV1");
      }


      var pathParams = {
        'srid': srid,
        'tileZ': tileZ,
        'tileX': tileX,
        'tileY': tileY,
        'fileExtension': fileExtension
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = 'Blob';

      return this.apiClient.callApi(
        '/api/v1/world-imagery/{srid}/{tileZ}/{tileX}/{tileY}.{fileExtension}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

